import HorizontalCenter from '@components/common/alignment/HorizontalCenter';
import { FileInfo } from '@data/course/courseData';
import React from 'react';
import FileDisplay from './FileDisplay';

interface CurriculumFileViewerProps {
  files: FileInfo[];
}

const CurriculumFileViewer = ({ files }: CurriculumFileViewerProps) => {
  return (
    <div>
      {files.map((f, index) => (
        <HorizontalCenter key={index}>
          <FileDisplay file={f}></FileDisplay>
        </HorizontalCenter>
      ))}
    </div>
  );
};

export default CurriculumFileViewer;
